import styled from 'styled-components';
import { Button } from '@grupoboticario/flora-react';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  padding: 0px 0px 72px;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: calc(100vh - 136px);
  height: fit-content;
  padding: 0 15px 15px;
`;

export const Header = styled.div`
  width: 100%;
  max-width: 570px;
  text-align: left;
  margin: 30px 0 18px;
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.main};
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  padding-bottom: 8px;
  border-bottom: 3px solid ${({ theme }) => theme.colors.main};
  width: fit-content;
`;

export const CloseButton = styled(Button)`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  & svg {
    height: 16px;
    width: 16px;
    margin-left: 10px;
  }
  & svg path {
    color: #fff;
  }
  &.first {
    position: absolute;
    top: 0;
    right: 0;
  }
  &.last {
    position: relative;
    margin: auto;
  }
`;
